import { Component, OnInit } from '@angular/core';
import { User } from '../models/user.model';
import { Storage } from '@ionic/storage-angular';
import { AccountService } from '../services/account.service';
import { LanguageService } from '../services/language.service';
import { interval, Subscription, timer } from 'rxjs';
import { VisitorService } from './services/visitor.service';
import { VisitService } from './services/visit.service';
import { map, share } from 'rxjs/operators';
import { Router } from '@angular/router';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.css']
})
export class AdminComponent implements OnInit {

  loggedUser$ = this.accountService.currentUser$;
  dateTime: string;
  time = new Date();
  rxTime = new Date();
  intervalId;
  subscription: Subscription;
  /*  */
  i: number;
  paginationSettings = { totalItems: 0 };
  // eslint-disable-next-line @typescript-eslint/no-inferrable-types
  currentPage: number = 1;
  // eslint-disable-next-line @typescript-eslint/no-inferrable-types
  itemsPerPage: number = 20;
  // eslint-disable-next-line @typescript-eslint/no-inferrable-types
  fullNameQuery: string = '';
  // eslint-disable-next-line @typescript-eslint/no-inferrable-types
  birthDateQuery: string = '';
  // eslint-disable-next-line @typescript-eslint/no-inferrable-types
  roomQuery: string = '';
  // eslint-disable-next-line @typescript-eslint/no-inferrable-types
  statusQuery: string = '';
  /* visits$ = this.visitService.visit$;
  visitors$ = this.visitorService.visitors$; */
  pageSize: number = 2147483647;
  /*  */

  constructor(private accountService: AccountService, private languageService: LanguageService,
    private storage: Storage, private visitService: VisitService, private router: Router) {
  }

  ngOnInit() {
  }

  isActivePage(pageName): boolean {
    const currentPath = window.location.href.split('/').pop();
    return currentPath.startsWith(pageName);
  }

  forceReloadCallList() {
  
  this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
    this.router.navigate(['/admin/call-list']);
  });
}

statusOpen=false;
 onStatusToggle(changedStatus: any) {

}


}
